import styled from '@emotion/styled';

export const Container = styled.div`
	display: flex;
	gap: 0.5rem;
	overflow: hidden;

	& > * {
		flex-shrink: 0.05;
		overflow: hidden;
	}

	& > *:first-of-type {
		flex-shrink: 0;
	}
`;
